export enum dialogType {
    actionKpiCharts,
    actionConfiguraion
}